import React from 'react';
import { Text, useStyleConfig } from '@chakra-ui/react';
export const Caption = (props) => {
    const styles = useStyleConfig('Caption', props);
    return React.createElement(Text, { sx: styles, ...props });
};
//# sourceMappingURL=Caption.js.map